module.exports = __webpack_public_path__ + "static/media/graphql-icon.e7f32a3e.png";